module.exports = __webpack_public_path__ + "images/emoji/arrows_clockwise.f5c10370a78574545f07.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrows_clockwise.png
// module id = t3dK
// module chunks = 1